import { render, staticRenderFns } from "./AppSimpleTextField.vue?vue&type=template&id=332c24cf&scoped=true&"
import script from "./AppSimpleTextField.vue?vue&type=script&lang=ts&"
export * from "./AppSimpleTextField.vue?vue&type=script&lang=ts&"
import style0 from "./AppSimpleTextField.vue?vue&type=style&index=0&id=332c24cf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "332c24cf",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VForm,VTextField})
